import { useMemo } from "react";
import { useShallow } from "zustand/react/shallow";

import { MainNavigationMenuItem } from "components/MainNavigation/types";
import useAiChatStore from "components/AssistantPanel/Layout/useStore";
import useAssistantPanelAvailable from "hooks/useAssistantPanelAvailable";

// TODO: move to a generated icons
const GradientSparksIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient
        id="sparks-gradient"
        x1="21.3039"
        y1="-9.32739"
        x2="-3.76391"
        y2="-1.94902"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F0883E" />
        <stop offset="1" stopColor="#7C47FC" />
      </linearGradient>
    </defs>
    <path
      d="M18.25 9.5a.937.937 0 0 1-.937-.937 1.875 1.875 0 0 0-1.875-1.876.937.937 0 0 1 0-1.875 1.875 1.875 0 0 0 1.874-1.875.938.938 0 0 1 1.875 0 1.875 1.875 0 0 0 1.875 1.876.937.937 0 0 1 0 1.875 1.875 1.875 0 0 0-1.875 1.875.94.94 0 0 1-.937.937M9.5 22a1.25 1.25 0 0 1-1.25-1.25 5 5 0 0 0-5-5 1.25 1.25 0 0 1 0-2.5 5 5 0 0 0 5-5 1.25 1.25 0 0 1 2.5 0 5 5 0 0 0 5 5 1.25 1.25 0 0 1 0 2.5 5 5 0 0 0-5 5A1.25 1.25 0 0 1 9.5 22"
      fill="url(#sparks-gradient)"
    />
  </svg>
);

const AI_CHAT_MENU_ITEM_ID = "ai-chat";

const useAiChatItem = (): MainNavigationMenuItem | undefined => {

  const isAssistantPanelAvailable = useAssistantPanelAvailable();

  const setIsOpen = useAiChatStore(useShallow((state) => state.setIsOpen));

  const item = useMemo(
    () => ({
      id: AI_CHAT_MENU_ITEM_ID,
      title: "Ask Saturnhead",
      icon: GradientSparksIcon,
      onAction: () => setIsOpen(true),
    }),
    [setIsOpen]
  );

  if (!isAssistantPanelAvailable) {
    return undefined;
  }

  return item;
};

export default useAiChatItem;
